import { useState, type ReactNode } from 'react';

import { docsImageUrl } from '../../lib/docsAsset';
import { DocsAssetFallback } from './DocsAssetFallback';

interface FigureProps {
  /** CDN 키. `docs/` prefix 는 붙이지 않는다 (docsImageUrl 이 붙인다). */
  src: string;
  alt: string;
  /** 캡처 창 제목 표시줄에 넣을 문구. 없으면 표시줄을 그리지 않는다. */
  window?: string;
  children?: ReactNode;
}

/**
 * 정지 캡처. 문서 미디어의 기본값이고 실제로 90% 는 이걸로 끝난다.
 *
 * 가로로 넓은 적산 화면이 들어오므로 본문 폭을 넘으면 프레임 안에서만 가로 스크롤한다.
 * 페이지 body 가 가로로 밀리면 안 된다.
 */
export function Figure({ src, alt, window: windowTitle, children }: FigureProps) {
  const [missing, setMissing] = useState(false);

  return (
    <figure className="my-7">
      <div className="overflow-hidden rounded-xl border border-neutral-200 dark:border-white/12">
        {windowTitle && (
          <div className="flex items-center gap-1.5 border-b border-neutral-200 bg-neutral-50 px-3 py-2 dark:border-white/12 dark:bg-white/5">
            <span aria-hidden className="h-2 w-2 rounded-full bg-neutral-300 dark:bg-white/20" />
            <span aria-hidden className="h-2 w-2 rounded-full bg-neutral-300 dark:bg-white/20" />
            <span aria-hidden className="h-2 w-2 rounded-full bg-neutral-300 dark:bg-white/20" />
            <span className="ml-2 text-[10.5px] text-neutral-400">{windowTitle}</span>
          </div>
        )}
        {missing ? (
          <DocsAssetFallback assetKey={src} alt={alt} />
        ) : (
          <div className="overflow-x-auto">
            <img
              src={docsImageUrl(src, { format: 'auto' })}
              alt={alt}
              loading="lazy"
              decoding="async"
              onError={() => setMissing(true)}
              className="block max-w-none"
            />
          </div>
        )}
      </div>
      {children && (
        <figcaption className="mt-2.5 text-[12.5px] leading-6 text-neutral-500 dark:text-neutral-400">
          {children}
        </figcaption>
      )}
    </figure>
  );
}
